import {
	API_ERROR,
	PRODUCT_QUALITIES_ADD,
	PRODUCTS_QUALITIES,
	PRODUCT_QUALITIES_DELETE,
	MODEL_OPEN,
	MODEL_CLOSE,
	PRODUCT_QUALITIES_LIST_SUCCESSFUL,
	PRODUCT_QUALITIES_ADD_SUCCESSFUL,
	PRODUCT_QUALITY_EDIT_SUCCESSFUL,
	PRODUCT_QUALITY_EDIT,
	PRODUCT_QUALITY_SETROWDATA,
	PRODUCT_QUALITIES_ROW_SUCCESSFUL,
	GET_PRODUCT_QUALITIES_ROW_DATA,
	PRODUCT_QUALITIES_CHANGEVALUE,
	PRODUCT_QUALITIES_SELECT_CHANGEVALUE,
	SET_PARAMS
} from "./actionTypes";

const initialState = {
	error: "Sorry! No Data Found.",
	message: null,
	loading: false,
	qualityProductlist: [],
	model: false,
	error_msg: null,
	rowdata: {},
	params: {
		no_of_pages: 0,
		page_size: 10,
		page: 1,
		search: "",
		currentSort: "code",
		sortOrder: "-",
	},
	
};

const qualityProduct = (state = initialState, action) => {
	switch (action.type) {
		case PRODUCTS_QUALITIES:
			state = {
				...state,
				loading: true,
			};
			break;
		case PRODUCT_QUALITIES_LIST_SUCCESSFUL:
			var noofpages = Math.ceil(
				action.payload.response.count / state.params.page_size
			);
			state = {
				...state,
				qualityProductlist: action.payload.response.results,
				loading: false,
				params: {
					...state.params,
					no_of_pages: noofpages,
				},
			};
			break;
		case PRODUCT_QUALITIES_CHANGEVALUE:
			state = {
				...state,
				rowdata: {
					...state.rowdata,
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case PRODUCT_QUALITIES_SELECT_CHANGEVALUE:
			state = {
				...state,
				rowdata: {
					...state.rowdata,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case PRODUCT_QUALITIES_ADD:
			state = {
				...state,
				loading: false,
			};
			break;
		case PRODUCT_QUALITIES_ADD_SUCCESSFUL:
			state = {
				...state,
				message: action.payload,
				loading: false,
				model: false,
				// rowdata: {Id:0},
			};
			break;
		case PRODUCT_QUALITY_EDIT:
			state = {
				...state,
				model: true,
				rowdata: action.payload,
			};
			break;
		case PRODUCT_QUALITY_EDIT_SUCCESSFUL:
			state = {
				...state,
				loading: false,
				rowdata: { Id: 0 },
			};
			break;
		case PRODUCT_QUALITIES_DELETE:
			state = {
				...state,
				loading: false,
			};
			break;
		case PRODUCT_QUALITY_SETROWDATA:
			state = {
				...state,
				rowdata: action.payload,
				// model: true,
			};
			break;
		case MODEL_OPEN:
			state = {
				...state,
				model: true,
			};
			break;
		case MODEL_CLOSE:
			state = {
				...state,
				model: false,
				rowdata: { id: 0 },
			};
			break;
		case API_ERROR:
			state = {
				...state,
				loading: false,
				error_msg: action.payload,
			};
			break;

		case GET_PRODUCT_QUALITIES_ROW_DATA:
			state = {
				...state,
				loading: true,
			};
			break;
		case PRODUCT_QUALITIES_ROW_SUCCESSFUL:
			state = {
				...state,
				rowdata: action.payload.response,
				loading: false,
			};
			break;
		case SET_PARAMS:
			state = {
				...state,
				params: action.payload,
			};
			break;

		default:
			state = { ...state };
			break;
	}
	return state;
};

export default qualityProduct;
